import axios from "axios";
import {
  OPERACIONES_BASE_URL,
  OPERACIONES_PATHS,
  OPERACIONES_REQUEST_TIMEOUT,
} from "./operaciones.constants";
import { mapOperacionesResponse } from "./operaciones.mapper";

const JSON_HEADERS = { "Content-type": "application/json" };

const REQUEST_CONFIG = {
  headers: JSON_HEADERS,
  timeout: OPERACIONES_REQUEST_TIMEOUT,
};

function buildApiUrl(base, path, envName) {
  if (!base) {
    throw new Error(`Falta la variable de entorno ${envName}.`);
  }

  return `${base}${path}`;
}

function getOperacionesUrl(path) {
  return buildApiUrl(
    OPERACIONES_BASE_URL,
    path,
    "VUE_APP_REPORT_VTEX_BASE",
  );
}

export function getOperacionesErrorMessage(error) {
  if (error?.message?.startsWith("Falta la variable de entorno")) {
    return error.message;
  }

  if (error?.code === "ECONNABORTED") {
    return "La solicitud tardó demasiado. Intente nuevamente.";
  }

  return error?.response?.data?.message || "Error al cargar las operaciones.";
}

export async function fetchOperaciones(idPeriodo, idProv) {
  const url = getOperacionesUrl(OPERACIONES_PATHS.operaciones);
  const params = { idPeriodo };
  if (Number(idProv) > 0) {
    params.idProv = idProv;
  }
  const { data } = await axios.get(url, {
    ...REQUEST_CONFIG,
    params,
  });

  return mapOperacionesResponse(data);
}
export async function guardarOcMigoMasivo(payload = {}) {
  const url = getOperacionesUrl(OPERACIONES_PATHS.guardarOcMasivo);
  const { data } = await axios.post(url, payload, REQUEST_CONFIG);
  return data;
}
export async function guardarOcMigo(payload = {}) {
  const url = getOperacionesUrl(OPERACIONES_PATHS.guardarOc);
  const { data } = await axios.post(url, payload, REQUEST_CONFIG);
  return data;
}

export async function validarOcMigoMasivo(payload = {}) {
  const url = getOperacionesUrl(OPERACIONES_PATHS.validarOcMasivo);
  const { data } = await axios.post(url, payload, REQUEST_CONFIG);
  return data;
}

export async function cargarPdfOcMasivo(formData, onUploadProgress) {
  const url = getOperacionesUrl(OPERACIONES_PATHS.cargarPdfOcMasivo);
  const { data } = await axios.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 300000,
    onUploadProgress,
  });
  return data;
}